import React, { useEffect } from 'react'
import { Button, Grid, Card, makeStyles } from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { Formik, Form } from 'formik'
import ViewHeader from 'components/ViewHeader'
import ProgressButton from 'components/ProgressButton'
import ActionBar from 'components/ActionBar'
import CustomTextField from 'components/Form/CustomTextField'
import {
  addModerator,
  checkModeratorIsUnique,
  fetchModeratorById,
  resetModerator,
  updateModeratorById
} from 'store/moderator'
import { moderatorFormSchema } from 'schemas/moderator'

const ModeratorForm = ({ displayContext, onSuccess, onCloseModal }) => {
  const classes = useStyles()
  const { moderatorId } = useParams()
  const { user } = useSelector((state) => state.auth)
  const dispatch = useDispatch()
  const history = useHistory()

  const { moderator, inProgress } = useSelector((state) => state.moderator)

  const initialValues = {
    fullName: moderator?.fullName ?? ''
  }
  const goBack = () => {
    dispatch(resetModerator())
    history.goBack()
  }

  const onCancel = () => {
    if (displayContext === 'page') {
      goBack()
    } else {
      onCloseModal()
    }
  }

  useEffect(() => {
    if (moderatorId) {
      dispatch(fetchModeratorById(moderatorId))
    }
    return () => dispatch(resetModerator())
  }, [dispatch, moderatorId])

  const onSubmit = async ({ fullName }) => {
    const payload = {
      fullName: fullName.trim()
    }

    const doesModeratorExist = await dispatch(checkModeratorIsUnique(fullName))
    if (doesModeratorExist) {
      toast.error(`Moderator with this name already exists!`)
      return
    }

    let res, message
    if (moderatorId) {
      res = await updateModeratorById(moderatorId, payload)
      message = 'Moderator updated successfully'
    } else {
      res = await dispatch(addModerator(user?.conferenceId, payload))
      message = 'Moderator added successfully'
    }

    if (res && displayContext === 'page') {
      toast.success(message)
      goBack()
    }
    displayContext === 'modal' && onSuccess && onSuccess(res)
  }

  return (
    <Card
      elevation={displayContext === 'page' ? 3 : 0}
      className={displayContext === 'page' ? classes.card : classes.styledCard}>
      {displayContext === 'page' && (
        <ViewHeader title={moderatorId ? 'Edit moderator' : 'Create moderator'}>
          <ActionBar actionText="Back" onAction={goBack} />
        </ViewHeader>
      )}
      <Formik
        enableReinitialize
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationSchema={moderatorFormSchema}>
        <Form>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <CustomTextField label="Full Name" name="fullName" type="text" />
            </Grid>
          </Grid>
          <Grid container justifyContent="flex-end" spacing={2} style={{ marginTop: '1rem' }}>
            <Grid item>
              <Button disabled={inProgress} size="large" onClick={onCancel}>
                Cancel
              </Button>
            </Grid>
            <Grid item>
              <ProgressButton
                type="submit"
                label="Save"
                inProgress={inProgress}
                disabled={inProgress}
              />
            </Grid>
          </Grid>
        </Form>
      </Formik>
    </Card>
  )
}
export default ModeratorForm

const useStyles = makeStyles({
  card: {
    padding: '24px',
    overflow: 'visible'
  },
  styledCard: {
    paddingTop: '1rem'
  }
})
